export const formatRut = (rut: string): string => {
  if (!rut) {
    return '';
  }
  const cleanRut = clean(rut);

  let result =
    cleanRut.slice(-4, -1) + '-' + cleanRut.slice(cleanRut.length - 1);
  for (let i = 4; i < cleanRut.length; i += 3) {
    result = cleanRut.slice(-3 - i, -i) + '.' + result;
  }

  return result;

  function clean(rut: string) {
    return typeof rut === 'string'
      ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase()
      : '';
  }
};
